import { Component, Output, OnInit, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import * as $ from 'jquery';
import { CairoService } from '../fittings/cairo.service';
import { AuthService } from '../auth/auth.service';

/*
 * Classic (Bootstrap) controls of the Cairo screen: native <select>s and a
 * current/target table. Same public API as the studio controls
 * (load()/value/onSelection) so LegacyFittingsComponent mirrors FittingsComponent.
 */


@Component({
    selector: 'legacy-customer-selector',
    template: `
        <select #sel class="custom-select mb-3 select-horizons" (change)="onChange($event)">
            <option *ngFor="let customer of customers">{{ customer }}</option>
        </select>
    `
})
export class LegacyCustomerSelectorComponent implements OnInit {

    @Output() onSelection = new EventEmitter<string>();
    @ViewChild('sel', {static: true}) sel: ElementRef;

    constructor(private srv: AuthService) { }
    customers: string[] = [];

    ngOnInit() {
        this.customers = this.srv.shops_list();
        if (this.customers.length > 0) {
            this.onSelection.emit(this.customers[0]);
        } else {
            this.onSelection.emit(this.srv.shop_id())
        }
    }

    get value(): string { return this.sel.nativeElement.value; }

    onChange(event) {
        let selector = event.target || event.srcElement;
        let customer = selector.options[selector.selectedIndex].value;
        this.onSelection.emit(customer);
    }
}


@Component({
    selector: 'legacy-machine-selector',
    template: `
        <select #sel class="custom-select mb-3 select-horizons" (change)="onChange($event)">
            <option *ngFor="let machine of machines" value="{{ machine.name }}">
                {{ label(machine) }}
            </option>
        </select>
    `
})
export class LegacyMachineSelectorComponent implements OnInit {

    @Output() onSelection = new EventEmitter<string>();
    @ViewChild('sel', {static: true}) sel: ElementRef;

    constructor(private srv: CairoService, private auth: AuthService) { }
    machines: any[] = [];

    ngOnInit() {
        let mycustomer = this.auth.shop_id();
        if (mycustomer) {
            this.load(mycustomer);
        }
    }

    public load(customer: string) {
        this.srv.machines(customer).then((m: any[]) => {
            this.machines = m;

            if (this.machines.length > 0) {
                this.onSelection.emit(this.machines[0].name);
            }
        });
    }

    get value(): string { return this.sel.nativeElement.value; }

    /** "01 - Satis 1200 Valencia" when the customer named the machine (machineNames in cairo.json), else "01". */
    label(m: any): string { return m.alias ? `${m.name} - ${m.alias}` : m.name; }

    onChange(event) {
        let selector = event.target || event.srcElement;
        let machine = selector.options[selector.selectedIndex].value;
        this.onSelection.emit(machine);
    }
}


@Component({
    selector: 'legacy-recipe-selector',
    template: `
        <select #sel class="custom-select mb-3 select-horizons" (change)="onChange($event)">
            <option *ngFor="let recipe of recipes" value="{{ recipe.name }}">
                {{ recipe.alias }}
            </option>
        </select>
    `
})
export class LegacyRecipeSelectorComponent {

    @Output() onSelection = new EventEmitter<string>();
    @ViewChild('sel', {static: true}) sel: ElementRef;

    constructor(private srv: CairoService) { }
    recipes: any[] = [];

    public load(customer: string, machine: string) {
        this.srv.recipes(customer, machine).then((r: any[]) => {
            this.recipes = r;
            if (this.recipes.length > 0) {
                this.onSelection.emit(this.recipes[0].name);
            }
        });
    }

    get value(): string { return this.sel.nativeElement.value; }

    onChange(event) {
        let selector = event.target || event.srcElement;
        let recipe = selector.options[selector.selectedIndex].value;
        this.onSelection.emit(recipe);
    }
}


@Component({
    selector: 'legacy-substrate-selector',
    template: `
        <select #sel class="custom-select mb-3 select-horizons">
            <option *ngFor="let substrate of substrates">
                {{ substrate }}
            </option>
        </select>
    `
})
export class LegacySubstrateSelectorComponent {

    @ViewChild('sel', {static: true}) sel: ElementRef;

    constructor(private srv: CairoService) { }
    substrates: string[] = [];

    public load(customer: string, machine: string, recipe: string) {
        this.srv.substrates(customer, machine, recipe).then((s: string[]) => {
            this.substrates = s;
        });
    }

    get value(): string { return this.sel.nativeElement.value; }
}


@Component({
    selector: 'legacy-spectrophotometer',
    template: `
        <select #sel class="custom-select mb-3 select-horizons">
            <option *ngFor="let spect of spectrophotometers" value="{{ spect.id }}">
                {{ spect.name }}
            </option>
        </select>
    `
})
export class LegacySpectrophotometerComponent implements OnInit {

    @ViewChild('sel', {static: true}) sel: ElementRef;

    constructor(private srv: CairoService) { }
    spectrophotometers = [];

    ngOnInit() {
        this.spectrophotometers = this.srv.spectrophotometers();
    }

    /** Narrows the list to the machine's spectrophotometers (see CairoService.spectrophotometersFor). */
    load(customer: string, machine: string) {
        this.srv.spectrophotometersFor(customer, machine).then(list => {
            this.spectrophotometers = list;
        });
    }

    get value(): string { return String(this.sel.nativeElement.value); }
}


@Component({
    selector: '[legacy-value-pair-table]',
    template: `
        <th scope="row">{{ name }}</th>
        <td>
            <div class="units" [ngClass]='units'>
                <input id="{{id}}-old" [attr.readonly]="both_readonly ? true : null" class="form-control" type="number">
                <span></span>
            </div>
        </td>
        <td>
            <div class="units" [ngClass]='units'>
                <input id="{{id}}-new" readonly class="form-control" type="number">
                <span></span>
            </div>
        </td>
    `,
    styleUrls: ['./legacy-layers.components.css']
})
export class LegacyPairTableComponent {
    @Input() id: string;
    @Input() name: string;
    @Input() units: string = 'nm';
    @Input() both_readonly: boolean = false;
}


@Component({
    selector: 'legacy-layers-values',
    template: `
        <div *ngIf="error" class="card bg-warning mb-3" style="max-width: 18rem;">
            <div class="card-body">
                <h5 class="card-title">Warning</h5>
                <p class="card-text">Something went wrong<br>Please contact with
                    <a href="mailto:coatings@horizonsoptical.com">coatings@horizonsoptical.com</a>
                </p>
            </div>
        </div>
        <table *ngIf="!error" class="table table-hover">
            <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col">current</th>
                    <th scope="col">target</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let layer of make_array(); let i = index;" legacy-value-pair-table name="{{ layers[i] }}" id="{{i}}"></tr>
                <tr [class.d-none]="!result" legacy-value-pair-table id="Rvis" name="Rvis" units="percentage" both_readonly="true"></tr>
                <tr [class.d-none]="!result" legacy-value-pair-table id="L" name="L" units="" both_readonly="true"></tr>
                <tr [class.d-none]="!result" legacy-value-pair-table id="Chroma" name="Chroma" units="" both_readonly="true"></tr>
                <tr [class.d-none]="!result" legacy-value-pair-table id="Hue" name="Hue" units="degree" both_readonly="true"></tr>
            </tbody>
        </table>
    `,
    styleUrls: ['./legacy-layers.components.css']
})
export class LegacyTableValuesComponent {
    layers: string[] = [];

    make_array(): any[] {
        return Array(this.layers.length);
    }

    constructor(private srv: CairoService) { }

    public load(customer: string, machine: string, recipe: string) {
        this.srv.layers(customer, machine, recipe).then((layers: string[]) => {
            this.layers = layers;
        });
    }

    public get_layers() {
        return this.layers.map((name, idx) => {
            return $('#' + idx + '-old')[0].value;
        })
    }

    private readonly DecimalsMap = {
        Rvis: 2,
        L: 1,
        Chroma: 1,
        Hue: 0,
    }

    error: boolean = false;
    result: boolean = false;

    public show(results) {
        this.error = (results.debug.CSQ2 > (results.debug.CSQ1 * 0.75));

        results.layers.forEach((value, idx) => {
            const el = $('#' + idx + '-new')[0];
            if (el) { el.value = value; }
        });

        this.result = true;

        results.parameters.forEach(param => {
            let key = param.key;
            let value = param.value
            if (key in this.DecimalsMap) {
                value = Math.round(value * Math.pow(10, this.DecimalsMap[key])) / Math.pow(10, this.DecimalsMap[key]);
            }
            const el = $('#' + key + '-old')[0];
            if (el) { el.value = value; }
        });

        results.target_parameters.forEach(param => {
            let key = param.key.substr(1);
            let value = param.value
            if (key in this.DecimalsMap) {
                value = Math.round(value * Math.pow(10, this.DecimalsMap[key])) / Math.pow(10, this.DecimalsMap[key]);
            }
            const el = $('#' + key + '-new')[0];
            if (el) { el.value = value; }
        });
    }
}
